import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Text from '@components/Text';
import styled from '@emotion/styled';

interface Props {
    couponNo: string;
}

function CouponBarcode({ couponNo }:Props) {
    return (
        <Wrapper>
            <Container align='center' spacing={6} >
                <CustomBarcode value={couponNo}
                    height={42} />
                <Text>{couponNo}</Text>
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding: 24px 20px;
    width: 100%;
`;

const Container = styled(Column)`
    background-color: var(--color-white);
    border-radius: 8px;
    box-shadow: 0 2px 16px 0px rgba(0, 0, 0, 0.14);
    padding: 12px 12px 6px;
    width: 100%;
`;

export default CouponBarcode;
